import React from "react";
import { Link } from "../../common/components/link";
import StringsHelper from "../../common/stringsHelper";
import { AccountData } from "../../generated";
import { requiresUser } from "../../login/loginHelpers";
import { links } from "../../routes";

const RemainingSmsWidget = (props: { user: AccountData }) => {
    return <div className="card card-inverse bg-secondary shadow">
        <div className="card-body text-center">
            <div className="d-flex justify-content-center align-items-center">
                <div className="me-3">
                    <i className="fas fa-sms text-white fa-3x"></i>
                </div>
                <div>
                    <h3 className="text-white">SMS Residui</h3>
                </div>
            </div>
            <div className="font-light text-white fs-1">
                {StringsHelper.toIntegerString(props.user.remainingSms)}
            </div>
            <Link to={links.buySms} className="btn btn-success w-100">Acquista SMS</Link>
        </div>
    </div>

}

export default requiresUser(RemainingSmsWidget);